import { TableColumn } from '@silverfort/sf-components';
import { DomainType, LocalAccountType } from '../../types/LocalAccount';
import { BoundUserRow } from './components/LocalAccountDrawer/BoundAccountsTable';
import { DateFormat, formatDate } from '../../../../utils/dates';
import NameCell from './components/NameCell';
import ManageCell from './components/ManageCell';
import StatusCell from './components/StatusCell';
import BoundUserNameCell from './components/LocalAccountDrawer/BoundUserNameCell';
import { StatusCell as UsersTableStatusCell } from '../UsersTable/components';
import { LocalAccountRow } from './types';

export const LOCAL_ACCOUNT_TYPE_TO_LABEL: Record<LocalAccountType, string> = {
    [LocalAccountType.USER]: 'User',
    [LocalAccountType.GUEST]: 'Guest',
    [LocalAccountType.ADMINISTRATOR]: 'Administrator'
};

export const LOCAL_ACCOUNTS_TABLE_SORT_VALUES: Record<string, string | string[]> = {
    userName: 'userName',
    excludeTill: ['excludeTill', 'boundAdEntityGuid'],
    hostname: 'hostname',
    accountType: 'accountType',
    isDisabled: 'isDisabled',
    lastLogon: 'lastLogon',
}

export const LOCAL_ACCOUNTS_TABLE_COLUMNS: TableColumn<LocalAccountRow>[] = [
    {
        columnKey: 'userName',
        title: 'Username',
        render: NameCell
    },
    {
        columnKey: 'excludeTill',
        title: 'Binding status',
        render: StatusCell,
    },
    {
        columnKey: 'hostname',
        title: 'Device name',
        render: (row) => row?.hostname
    },
    {
        columnKey: 'accountType',
        title: 'Account type',
        render: (row) => LOCAL_ACCOUNT_TYPE_TO_LABEL[row.accountType]
    },
    {
        columnKey: 'isDisabled',
        title: 'Status',
        render: (row) => (row.isDisabled ? 'Disabled' : 'Enabled')
    },
    {
        columnKey: 'lastLogon',
        title: 'Last logon',
        render: (row) => {
            if (!row.lastLogon) {
                return 'N/A';
            }
            return formatDate(row.lastLogon, DateFormat.READABLE_DATE);
        }
    },
    {
        columnKey: 'boundAdEntity',
        title: 'Bound entity',
        disableSort: true,
        render: (row) => row.boundAdEntity?.name || ''
    },
    {
        columnKey: 'manage',
        title: '',
        disableSort: true,
        render: ManageCell,
        columnClassName: '[&]:w-12 [&]:min-w-12 [&]:pr-0'
    }
];

export const BOUND_ACCOUNTS_TABLE_COLUMNS: TableColumn<BoundUserRow>[] = [
    {
        columnKey: 'name',
        title: 'Username',
        render: BoundUserNameCell
    },
    {
        columnKey: 'status',
        title: 'Pairing status',
        render: UsersTableStatusCell
    },
    {
        columnKey: 'domain',
        title: 'Domain'
    }
];

export const DOMAIN_TYPE_TO_LABEL: Record<DomainType, string> = {
    [DomainType.ACTIVE_DIRECTORY]: 'Active Directory',
    [DomainType.ENTRA_ID]: 'Entra ID',
    [DomainType.WORKGROUP]: 'Non-Domain'
};
